import React from 'react';
import {
  FieldContext,
  IFilterFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { defaultEventInput } from '../../../../utils/builder';
import { MaybeNil } from '../../../../utils/interfaces';
import FilterWidget from '../../../FilterWidget';
import { IPredicateContext } from '../../../FilterWidget/types';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { IRowMeta, setFilterAction } from '../../../../redux/slices/oldBuilder';
import Popover from '../../../Popover';
import {
  activeSchemaIdSelector,
  defaultLogOpsSelector,
} from '../../../../redux/selectors/builder';
import { useDndEntityInternalContext } from '../../../DndEntity';

interface IProps {
  rowMeta: IRowMeta;
  anchorEl: React.MutableRefObject<HTMLElement | null>;
  globalFilter: MaybeNil<IFilterFieldsFragment>;
  onClose: () => void;
}

const predicateContext: IPredicateContext = Object.freeze({
  fieldContext: FieldContext.Filter,
  events: [defaultEventInput],
  func: null,
});

const GlobalFilterPredicatePopover = ({
  rowMeta,
  anchorEl,
  globalFilter,
  onClose,
}: IProps) => {
  const dispatch = useAppDispatch();

  const activeSchemaId = useAppSelector(activeSchemaIdSelector);

  const defaultLogOps = useAppSelector(defaultLogOpsSelector);

  const dndContext = useDndEntityInternalContext();

  const handleSubmitNewFilters = (newFilter: IFilterFieldsFragment) => {
    dispatch(
      setFilterAction({
        rowMeta,
        newFilter,
      }),
    );

    onClose();
  };

  return (
    <Popover anchor={anchorEl.current} isOpen close={onClose}>
      <FilterWidget
        onSubmit={handleSubmitNewFilters}
        schemaId={activeSchemaId}
        context={predicateContext}
        defaultFilter={dndContext?.defaultFilter ?? globalFilter}
        defaultLogOps={defaultLogOps}
      />
    </Popover>
  );
};

export default GlobalFilterPredicatePopover;
